
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 14.5a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5zm-9.5 0A2.5 2.5 0 115 12a2.5 2.5 0 01-2.5 2.5zm19 0A2.5 2.5 0 1124 12a2.5 2.5 0 01-2.5 2.5z"}})])
          )
        }
      }
    